<template>
  <div>
    <b-row>
      <b-col cols="12">
        <renewals-filter :get-report-data="getReport" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col
          cols="12"
        >
          <b-card
            no-body
          >
            <b-card-header>
              <b-card-title>Genel Toplam</b-card-title>
            </b-card-header>
            <b-row no-gutters>
              <b-col
                cols="12"
                md="8"
              >
                <b-card-body>
                  <b-row>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Toplam"
                        :value="reportData.grandTotals.totals"
                        icon="UmbrellaIcon"
                        color="info"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Oran"
                        :value="reportData.grandTotals.renewedRates"
                        icon="PercentIcon"
                        color="info"
                        prefix="%"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      class="mb-2"
                    >
                      <hr>
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                    >
                      <flat-card
                        title="Yenilendi"
                        :value="reportData.grandTotals.renewed"
                        icon="CheckCircleIcon"
                        color="success"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                    >
                      <flat-card
                        title="Yenilenmedi"
                        :value="reportData.grandTotals.notRenewed"
                        icon="XCircleIcon"
                        color="danger"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                    >
                      <flat-card
                        title="Beklemede"
                        :value="reportData.grandTotals.opens"
                        icon="ClockIcon"
                        color="warning"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <pie-charts
                  :categories-data="reportData.grandTotals.chartData.categories"
                  :series-data="reportData.grandTotals.chartData.series"
                  :colors-data="reportData.grandTotals.chartData.colors"
                  chart-type="donut"
                  :is-card="false"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col
          v-for="item in reportData.data"
          :key="item.id"
          cols="12"
        >
          <b-card no-body>
            <b-card-header>
              <b-card-title>{{ item.title }}</b-card-title>
            </b-card-header>
            <b-row no-gutters>
              <b-col
                cols="12"
                md="8"
              >
                <b-card-body>
                  <b-row>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Toplam"
                        :value="item.totals"
                        icon="UmbrellaIcon"
                        color="info"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Oran"
                        :value="item.renewedRates"
                        icon="PercentIcon"
                        color="info"
                        prefix="%"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      class="mb-2"
                    >
                      <hr>
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Yenilendi"
                        :value="item.renewed"
                        icon="CheckCircleIcon"
                        color="success"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Yenilenmedi"
                        :value="item.notRenewed"
                        icon="XCircleIcon"
                        color="danger"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-2"
                    >
                      <flat-card
                        title="Beklemede"
                        :value="item.opens"
                        icon="ClockIcon"
                        color="warning"
                      />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="mb-2"
              >
                <pie-charts
                  :categories-data="item.chartData.categories"
                  :series-data="item.chartData.series"
                  :colors-data="item.chartData.colors"
                  chart-type="donut"
                  :is-card="false"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import RenewalsFilter from '@/views/Insurance/FilterCards/RenewalsFilter.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'Renewals',
  components: {
    RenewalsFilter,
    LoadingCard,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    FlatCard,
    PieCharts,
  },
  computed: {
    renewalParams() {
      return this.$store.getters['insuranceRenewalsReports/renewalParams']
    },
    reportData() {
      return this.$store.getters['insuranceRenewalsReports/reportData']
    },
    loading() {
      return this.$store.getters['insuranceRenewalsReports/loading']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('insuranceRenewalsReports/getReportData', this.renewalParams)
    },
  },
}
</script>
